<template>
    <v-container class="main-container responsive-height">
        <v-row dense>
            <v-col cols="12" xl="12">
                <v-card class="live-trade-details-card rounded-0" elevation="0"
                    :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
                    <v-row class="no-gutters">
                        <v-col cols="12" sm="6" md="6" lg="3">
                            <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search here ..."
                                single-line solo hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="2">
                            <v-select solo :items="allSymbols()" v-model="account" @input="accountFilter"
                                append-icon="mdi-chevron-down" label="Select Symbol" class="custom-select"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-dialog ref="dialog" v-model="modal" :return-value.sync="dates" width="290px" class="">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="dateRangeText" prepend-icon="mdi-calendar"
                                        append-icon="mdi-chevron-down" readonly v-bind="attrs" v-on="on" solo
                                        class="custom-select"></v-text-field>
                                </template>
                                <v-date-picker v-model="dates" @input="dateFilter" class="custom-date-picker" scrollable
                                    range>
                                    <v-spacer></v-spacer>
                                    <v-btn :color="$vuetify.theme.dark
                                        ? '#ff567f'
                                        : '#ff567f'
                                        " text @click="cancelAction">
                                        Cancel
                                    </v-btn>
                                    <v-btn :color="$vuetify.theme.dark
                                        ? '#fff'
                                        : '#131c29'
                                        " text @click="$refs.dialog.save(date)">
                                        OK
                                    </v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="4">
                            <ul>
                                <li>
                                    <span>Total Equity:</span>
                                    <span>{{
                                        accountSpecificLiveTradesSummary.Equity.toFixed(
                                            2
                                        )
                                    }}</span>
                                </li>
                                <li>
                                    <span>Total Lot:</span>
                                    <span>{{
                                        accountSpecificLiveTradesSummary.totalLot.toFixed(
                                            2
                                        )
                                    }}</span>
                                </li>
                                <li>
                                    <span class="profit-loss">Profit / Loss:</span>
                                    <span>{{
                                        accountSpecificLiveTradesSummary.profitLoss.toFixed(
                                            2
                                        )
                                    }}</span>
                                </li>
                            </ul>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-card class="pa-3 rounded-0 elevation-0 mt-6" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'
                                ">
                                <v-sheet class="transactionTable liveTradeTable pb-3" :color="$vuetify.theme.dark
                                    ? '#1A2A3E '
                                    : '#F1F7FB'
                                    ">
                                    <v-data-table :headers="headers" :items="filteredData" :search="search"
                                        :items-per-page="6">
                                        <template v-slot:item.serial="{ item, index }">
                                            <span>
                                                {{ index + 1 }}
                                            </span>
                                        </template>
                                        <template v-slot:item.TimeCreate="{ item }">
                                            <span>
                                                {{
                                                    formatMySQLDate(
                                                        item.TimeCreate
                                                    )
                                                }}
                                            </span>
                                        </template>
                                        <template v-slot:item.Action="{ item }">
                                            <span class="profit-text-color">
                                                {{
                                                    item.Action === 0
                                                        ? "Buy"
                                                        : item.Action === 1
                                                            ? "Sell"
                                                            : null
                                                }}
                                            </span>
                                        </template>
                                        <template v-slot:item.Volume="{ item }">
                                            <span class="profit-text-color">
                                                {{ item.Volume / 10000 }}
                                            </span>
                                        </template>
                                        <template v-slot:item.PriceOpen="{ item }">
                                            <span class="profit-text-color">
                                                {{
                                                    item?.PriceOpen?.toFixed(5)
                                                }}
                                            </span>
                                        </template>
                                        <template v-slot:item.PriceSL="{ item }">
                                            <span class="profit-text-color">
                                                {{ item?.PriceSL?.toFixed(2) }}
                                                -
                                                {{ item?.PriceTP?.toFixed(2) }}
                                            </span>
                                        </template>
                                    </v-data-table>
                                </v-sheet>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRADING__ACTIONS } from "@/store/action-types";

export default {
    data() {
        return {
            headers: [
                { text: "Sl", value: "serial", align: "start" },
                { text: "Ticket", value: "Position", align: "start" },
                {
                    text: "Date & Time",
                    value: "TimeCreate",
                },
                { text: "Type", value: "Action" },
                { text: "Lots", value: "Volume" },
                { text: "Symbol", value: "Symbol" },
                { text: "Open price", value: "PriceOpen" },
                { text: "SL-TP", value: "PriceSL" },
                { text: "Running", value: "PriceCurrent" },
                { text: "Profit", value: "Profit" },
            ],
            modal: false,
            search: "",
            account: "",
            dates: [],
            filteredData: [],
        };
    },

    computed: {
        ...mapState("trading", [
            "tradingAccountLiveTrades",
            "accountSpecificLiveTradesSummary",
        ]),
        dateRangeText() {
            return ["2022-01-01", this.getCurrentDate()].join(" ~ ");
        },
    },
    methods: {
        formatMySQLDate(mysqlDate) {
            console.log(mysqlDate);

            // Ensure the input is in the correct format
            if (!mysqlDate) return "Invalid date";

            // Replace the "T" with a space to work with the current logic
            const isoFormattedDate = mysqlDate.replace('T', ' ').split('.')[0]; // Removes milliseconds
            const [datePart, timePart] = isoFormattedDate.split(' ');
            const [year, month, day] = datePart.split('-');
            const [hour, minute] = timePart.split(':');

            // Convert 24-hour time to 12-hour time
            const hour12 = hour % 12 || 12;
            const amPm = hour >= 12 ? 'pm' : 'am';

            // Return the formatted date and time
            return `${day}.${month}.${year} - ${hour12}:${minute} ${amPm}`;
        },
        getCurrentDate() {
            const currentDate = new Date();
            const formattedDate = currentDate.toISOString().split("T")[0];
            return formattedDate;
        },
        ...mapActions("trading", [TRADING__ACTIONS.CLIENTLIVETRADES]),
        allSymbols() {
            const symbols = this.tradingAccountLiveTrades.map(
                (acc) => acc.Symbol
            );
            return ["All", ...symbols];
        },

        dateFilter() {
            if (this.dates.length === 2) {
                let startDate = new Date(this.dates[0]);
                let endDate = new Date(this.dates[1]);

                if (startDate > endDate) {
                    [startDate, endDate] = [endDate, startDate];
                }

                // Increment the endDate by one day
                endDate.setDate(endDate.getDate() + 1);

                this.filteredData = this.tradingAccountLiveTrades.filter(
                    (item) => {
                        const tradeDate = new Date(
                            item.TimeCreate.split(" ")[0]
                        );
                        return tradeDate >= startDate && tradeDate <= endDate;
                    }
                );
            } else {
                this.filteredData = this.tradingAccountLiveTrades;
            }
        },

        accountFilter() {
            if (this.account === "All")
                return (this.filteredData = this.tradingAccountLiveTrades);
            this.filteredData = this.tradingAccountLiveTrades.filter(
                (item) =>
                    item.trading_account_no.toString() ===
                    this.account.toString()
            );
        },

        resetAll() {
            this.search = "";
            this.account = "";
            this.dates = [];
            this.filteredData = this.tradingAccountLiveTrades;
        },

        cancelAction() {
            this.modal = false;
            this.resetAll();
        },
    },
    async mounted() {
        await this[TRADING__ACTIONS.CLIENTLIVETRADES](this.$route.query.id);
        this.filteredData = this.tradingAccountLiveTrades;
        document.title = `Live Trade Details | ${this.accountSpecificLiveTradesSummary?.trading_account_no}`;
    },
};
</script>
